//node-modules
import { config } from "../config/config"
import { validate as isUuid } from 'uuid';

type Props = {
    urlProjectId: any
}

const Login = ({ urlProjectId }: Props) => {
    if (urlProjectId && isUuid(urlProjectId)) {
        // URL内にPJが存在する場合
        window.location.href = `${config.serverHost}/login?type=web&projectId=${urlProjectId}`;
    } else {
        // 上記以外
        window.location.href = `${config.serverHost}/login?type=web`;
    }
    
    return (
        <div className="Login">
        </div>
    );
}

export default Login;